export const checkStatusMap = {
  '0': { text: '待提审', color: 'yellow' },
  '-1': { text: 'AI审核中', color: 'yellow' },
  '1': { text: '上线中', color: 'yellow' },
  '2': { text: '上线中', color: 'yellow' },
  '3': { text: '未通过', color: 'red' },
  '4': { text: '仅我可见', color: 'yellow' },
  '5': { text: '未通过', color: 'red' },
  '-5': { text: '未通过', color: 'red' },
  '6': { text: '已发布', color: 'white' },
  '-6': { text: '仅我可见', color: 'yellow' },
  '-4': { text: '初审中', color: 'red' },
  '-2': { text: 'AI审核中', color: 'yellow' },
  '-3': { text: 'AI审核通过', color: 'white' },
  '20': { text: '审核通过', color: 'white' },
  '33': { text: '审核不通过', color: 'red' },
  '34': { text: '审核不通过', color: 'red' },
  '35': { text: '审核不通过', color: 'red' },
}
